import $ from "jquery";
import { url } from "../../../config.js";

export const MODERATOR_TOKEN_KEY = "moderator_token";

export function getModeratorToken(){
	return window.localStorage.getItem(MODERATOR_TOKEN_KEY);
}

export function clearModeratorToken(){
	window.localStorage.removeItem(MODERATOR_TOKEN_KEY);
}

export function login(username, password){
	return $.ajax({
		url: url.api_base_path + "moderator/login_api",
		type: "POST",
		data: {
			username,
			password
		}
	}).then((response) => {
		if(!response.token){
			throw new Error("Login response did not include a token.");
		}

		window.localStorage.setItem(MODERATOR_TOKEN_KEY, response.token);
		return response;
	});
}

export function logout(){
	return $.post(url.api_base_path + "moderator/logout_api")
		.always(clearModeratorToken);
}
